import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { VENDOR_ROUTES } from '../../../../common/constants/vendor.routing.constants';
import { RequestService } from '../../../../common/services/request/request.service';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { AccessKeyResponse } from '../../../../common/services/workflow-access-key/workflow-access-key.service';
import {
  RequestContextAdapter,
  RequestNavigationTarget,
} from './request-context.adapter';
import { VendorWorkflowAccessKeyService } from '../../../../common/services/vendor-workflow-access-key/vendor-workflow-access-key.service';

@Injectable({ providedIn: 'root' })
export class VendorRequestContextAdapter implements RequestContextAdapter {
  private readonly tenantService = inject(TenantService);
  private readonly requestService = inject(RequestService);
  private readonly workflowAccessKeyService = inject(
    VendorWorkflowAccessKeyService
  );

  private readonly vendorEndpoints = ENDPOINTS.VendorPortal;

  getAfterActionNavigation(): RequestNavigationTarget {
    return {
      commands: [
        this.tenantService.vendorPath(VENDOR_ROUTES.MY_INBOX.ASSIGNED_TASKS),
      ],
    };
  }

  getHomePath(): string {
    return this.tenantService.vendorPath(VENDOR_ROUTES.MY_INBOX.ASSIGNED_TASKS);
  }

  showCollaboratorsSection(): boolean {
    return false;
  }

  showSaveAction(): boolean {
    return false;
  }

  showRequestViewActions(): boolean {
    return false;
  }

  showHoldResumeActions(): boolean {
    return false;
  }

  getStepAuthorizationKey(
    stepId: string | number
  ): Observable<AccessKeyResponse> {
    return this.workflowAccessKeyService.getStepAuthorizationKey(stepId, null, {
      url: this.vendorEndpoints.Step.GenerateAccessKey.replace(
        '{stepId}',
        stepId.toString()
      ),
    });
  }

  refreshStepAuthorizationKey(
    stepId: string | number
  ): Observable<{ message: string }> {
    return this.workflowAccessKeyService.refreshStepAuthorizationKey(stepId, {
      url: this.vendorEndpoints.Step.RefreshAccessKey.replace(
        '{stepId}',
        stepId.toString()
      ),
    });
  }

  getFormSection(stepId: string | number): Observable<unknown> {
    return this.requestService.getFormSection(stepId, {
      url: this.vendorEndpoints.Step.FormSections.replace(
        '{stepId}',
        stepId.toString()
      ),
    });
  }

  takeStepAction(form: unknown, stepId: string | number): Observable<unknown> {
    return this.requestService.takeStepAction(form, stepId, {
      url: this.vendorEndpoints.Step.Assignees.replace(
        '{stepId}',
        stepId.toString()
      ),
    });
  }

  saveRequest(form: unknown, stepId: number): Observable<unknown> {
    return this.requestService.saveRequest(form, stepId, {
      url: this.vendorEndpoints.Step.Save.replace(
        '{stepId}',
        stepId.toString()
      ),
    });
  }

  getFlowSteps(flowId: string | number): Observable<unknown> {
    return this.requestService.getFlowSteps(flowId, {
      url: this.vendorEndpoints.Flow.Details.replace(
        '{flowId}',
        flowId.toString()
      ),
    });
  }

  getFlowStepsDetails(flowId: string | number): Observable<unknown> {
    return this.requestService.getFlowStepsDetails(flowId, {
      url: this.vendorEndpoints.Flow.FlowDetails.replace(
        '{flowId}',
        flowId.toString()
      ),
    });
  }
}
